module.exports = __webpack_public_path__ + "static/grocery-app-cover-f86341a4fc594db34e3f840a7a5108f7.png";